import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth } from '../redux/auth/selectors';

export const AuthGuard = ({ children }: { children: JSX.Element }) => {
  const user = useSelector(selectAuth);
  console.log('AuthGuard user', user)
  // return user?.isLoggedIn ? children : <Navigate to={`/auth/login`} />;
  return children;
};

export const RoleGuard = ({ children, roles }: { children: JSX.Element, roles: string[] }) => {
    const user = useSelector(selectAuth);
    console.log('RoleGuard user', user)
    // return user && roles.includes(user.role) ? children : <Navigate to="/" />;
    return children;

};
